import { createRouter, createWebHistory, createWebHashHistory } from "@ionic/vue-router";
import { isTauri } from "@/services/platform";
import { createChunkReloadHandler, clearChunkReloadMarker } from "./chunkReload";
import BottomMenu from "../views/layout/BottomMenu.vue";

const routes = [
    {
        path: "/",
        redirect: "/root/inspections",
    },
    {
        name: "inspection-show",
        path: "/inspections/:id",
        component: () => import("@/views/inspections/Edit.vue"),
        meta: { middleware: true },
    },
    // inspection-information
    {
        name: "inspection-information",
        path: "/inspection-information/:id",
        component: () => import("@/views/inspections/Information.vue"),
        meta: { middleware: true },
    },
    // list all findings
    {
        name: "findings-list",
        path: "/findings",
        component: () => import("@/views/Findings.vue"),
        meta: { middleware: true },
    },
    {
        path: "/root",
        component: BottomMenu,
        meta: {
            middleware: true,
        },
        children: [
            {
                path: "/root",
                redirect: "/root/inspections",
            },
            {
                path: "/root/dashboard",
                redirect: "/root/inspections",
            },
            {
                name: "inspections",
                path: "/inspections",
                redirect: "/root/inspections",
            },
            // Inspections
            {
                name: "inspections-list",
                path: "/root/inspections",
                component: () => import("@/views/inspections/Index.vue"),
                meta: { middleware: true },
            },

            // Actions
            {
                name: "actions-list",
                path: "actions",
                component: () => import("@/views/actions/Index.vue"),
                meta: { middleware: true },
            },

            // Account (redirect to settings)
            {
                path: "account",
                redirect: "/root/settings",
            },

            // Settings
            {
                name: "settings",
                path: "settings",
                component: () => import("@/views/Settings.vue"),
                meta: { middleware: true },
            },
        ],
    },
    // Support form
    {
        name: "support-form",
        path: "/support-form",
        component: () => import("@/views/SupportForm.vue"),
        meta: { middleware: true },
    },
    // image editor
    {
        name: "image-editor",
        path: "/image-editor",
        component: () => import("@/views/ImageEditorV3.vue"),
        meta: { middleware: true },
    },
    // camera
    // {
    //     name: "camera",
    //     path: "/camera",
    //     component: () => import("@/views/Camera.vue"),
    //     middleware: true,
    // },
    // action create
    {
        name: "action-create",
        path: "/action-create",
        component: () => import("@/views/actions/Create.vue"),
        meta: { middleware: true },
    },

    // action edit
    {
        name: "action-edit",
        path: "/action-edit",
        component: () => import("@/views/actions/Edit.vue"),
        meta: { middleware: true },
    },
    // Addresses
    {
        name: "addresses",
        path: "/addresses",
        component: () => import("@/views/Addresses.vue"),
        meta: { middleware: true },
    },
    // Location items
    {
        name: "location-item-edit",
        path: "/location-item-edit",
        component: () => import("@/views/location_items/Edit.vue"),
        meta: { middleware: true },
    },
    // location item create
    {
        name: "location-item-create",
        path: "/location-item-create",
        component: () => import("@/views/location_items/Create.vue"),
        meta: { middleware: true },
    },
    // Location item components
    {
        name: "location-item-component-edit",
        path: "/location-item-component-edit",
        component: () => import("@/views/location_item_components/Edit.vue"),
        meta: { middleware: true },
    },

    // Sub location item component
    {
        name: "sub-location-item-component-edit",
        path: "/sub-location-item-component-edit",
        component: () => import("@/views/location_item_components/Edit.vue"),
        meta: { middleware: true },
    },

    // observations
    {
        name: "observation-create",
        path: "/observation-create",
        component: () => import("@/views/observations/Create.vue"),
        meta: { middleware: true },
    },
    {
        name: "observation-show",
        path: "/observation-show",
        component: () => import("@/views/observations/Show.vue"),
        meta: { middleware: true },
    },
    {
        name: "observation-edit",
        path: "/observation-edit",
        component: () => import("@/views/observations/Edit.vue"),
        meta: { middleware: true },
    },

    //measurements
    {
        name: "measurement-create",
        path: "/measurement-create",
        component: () => import("@/views/measurements/Create.vue"),
        meta: { middleware: true },
    },
    {
        name: "measurement-show",
        path: "/measurement-show",
        component: () => import("@/views/measurements/Show.vue"),
        meta: { middleware: true },
    },
    {
        name: "measurement-edit",
        path: "/measurement-edit",
        component: () => import("@/views/measurements/Edit.vue"),
        meta: { middleware: true },
    },
    {
        name: "measurement-bulk",
        path: "/measurement-bulk",
        component: () => import("@/views/measurements/Bulk.vue"),
        meta: { middleware: true },
    },
    {
        path: "/login",
        name: "login",
        component: () => import("@/views/Login.vue"),
    },
    // image gallery
    {
        name: "image-gallery",
        path: "/image-gallery/:id",
        component: () => import("@/views/ImageGallery.vue"),
        meta: { middleware: true },
    },
    // location item tree
    {
        name: "location-item-tree",
        path: "/location-item-tree/:id",
        component: () => import("@/views/location_items/Index.vue"),
        meta: { middleware: true },
    },
    // forms index and edit. Gets a inspection id on index and form id on edit
    {
        name: "forms-inspection",
        path: "/forms-inspection/:id",
        component: () => import("@/views/forms/IndexFormInspections.vue"),
        meta: { middleware: true },
    },
    // IndexFormLocationItemComponents
    {
        name: "forms-location-item-component",
        path: "/forms-location-item-component/:id",
        component: () => import("@/views/forms/IndexFormLocationItemComponents.vue"),
        meta: { middleware: true },
    },
    // measurement instruments index, gets a inspection id on index and measurement id on edit
    {
        name: "measurement-instruments",
        path: "/measurement-instruments/:id",
        component: () => import("@/views/measurement_instruments/Index.vue"),
        meta: { middleware: true },
    },
    // location systems index and edit, gets a inspection id on index and location system id on edit
    {
        name: "location-systems",
        path: "/location-systems/:id",
        component: () => import("@/views/location_systems/Index.vue"),
        meta: { middleware: true },
    },

    // documents index and edit, gets a inspection id on index and document id on edit
    {
        name: "documents",
        path: "/documents/:id",
        component: () => import("@/views/documents/Index.vue"),
        meta: { middleware: true },
    },
    // checklists only index, gets a inspection id
    {
        name: "inspection-checklists",
        path: "/inspection-checklists/:id",
        component: () => import("@/views/checklists/InspectionChecklists.vue"),
        meta: { middleware: true },
    },
    // checklists for location_item_components, gets a location_item_component_uuid
    {
        name: "location-item-component-checklists",
        path: "/location-item-component-checklists/:id",
        component: () => import("@/views/checklists/LocationItemComponentChecklists.vue"),
        meta: { middleware: true },
    },
    {
        name: "regulations",
        path: "/regulations/:id",
        component: () => import("@/views/regulations/Index.vue"),
        meta: { middleware: true },
    },
    // inspewction-interval
    {
        name: "inspection-interval",
        path: "/inspection-interval/:id",
        component: () => import("@/views/inspection_interval/Index.vue"),
        meta: { middleware: true },
    },
    // observations index and edit, gets a location_item_component_uuid on index and location_item_component_uuid on edit
    {
        name: "observations",
        path: "/observations/:id",
        component: () => import("@/views/observations/Index.vue"),
        meta: { middleware: true },
    },
    // measurements index and edit, gets a location_item_component_uuid on index and location_item_component_uuid on edit
    {
        name: "measurements",
        path: "/measurements/:id",
        component: () => import("@/views/measurements/Index.vue"),
        meta: { middleware: true },
    },
    // ComponentDetails from location item components
    {
        name: "component-details",
        path: "/component-details/:id",
        component: () => import("@/views/location_item_components/ComponentDetails.vue"),
        meta: { middleware: true },
    },
    // Samples
    {
        name: "samples",
        path: "/samples/:id",
        component: () => import("@/views/samples/Index.vue"),
        meta: { middleware: true },
    },
    // Scios codes
    {
        name: "scios-codes",
        path: "/scios-codes/:id",
        component: () => import("@/views/scios_codes/Index.vue"),
        meta: { middleware: true },
    },
    // CloseInspectionPage
    {
        name: "close-inspection",
        path: "/close-inspection/:id",
        component: () => import("@/views/inspections/CloseInspection.vue"),
        meta: { middleware: true },
    },

    // Measurement types
    {
        name: "measurement-types",
        path: "/measurement-types",
        component: () => import("@/views/measurement_types/Index.vue"),
        meta: { middleware: true },
    },
    {
        name: "measurement-type-create",
        path: "/measurement-types/create",
        component: () => import("@/views/measurement_types/Create.vue"),
        meta: { middleware: true },
    },
    {
        name: "measurement-type-edit",
        path: "/measurement-types/edit",
        component: () => import("@/views/measurement_types/Edit.vue"),
        meta: { middleware: true },
    },
    {
        name: "measurement-type-revisions",
        path: "/measurement-types/revisions",
        component: () => import("@/views/measurement_types/RevisionHistory.vue"),
        meta: { middleware: true },
    },
];

const history = isTauri()
    ? createWebHashHistory()
    : createWebHistory(process.env.BASE_URL);

const router = createRouter({
    history,
    routes,
    strict: true,
});

router.beforeEach(async (to, from, next) => {
    const requiresAuth = to.matched.some(record => record.meta.middleware);
    if (requiresAuth) {
        const token = localStorage.getItem("bearer");
        if (token && token.length > 0) {
            return next();
        } else {
            return next({ name: "login", query: { redirect: to.path } });
        }
    } else {
        return next();
    }
});

// Reload to the target route when a lazy chunk fails to load after a deploy (see chunkReload.js).
router.onError(createChunkReloadHandler({
    storage: window.sessionStorage,
    reload: (fullPath) => window.location.assign(fullPath || window.location.href),
}));
router.afterEach((to) => clearChunkReloadMarker(window.sessionStorage, to));

export default router;
